<div data-cy="user-share-row" class="user-share-container">
    <div data-cy="user-share-role" class="subtitle-smaller light">
        {{ role }}
    </div>
    <div
        style="position: relative"
        [ngClass]="{ raisedContainer: optionsOpened }"
    >
        <div
            data-cy="user-share-admin-access"
            *ngIf="isOwner(); else optionWrapper"
            class="owner-label"
        >
            {{ "user-access.label.owner" | translate }}
        </div>
    </div>
</div>

<ng-template #optionWrapper>
    <div
        data-cy="user-share-access-dropdown-container"
        *ngIf="!optionsOpened; else optionsContainer"
        class="access-option-wrapper"
        (click)="openOptions(); $event.stopPropagation()"
        [ngClass]="{ 'disabled-option': shouldDisableOption() }"
    >
        <mat-icon class="lock-icon" svgIcon="{{ currentIcon }}"> </mat-icon>
        <div data-cy="user-share-access" class="subtitle-smaller light">
            {{ accessTypeTile.concat(".", currentAccess) | translate }}
        </div>
        <mat-icon
            data-cy="user-share-access-dropdown"
            class="arrow-icon"
            svgIcon="icon-down"
            *ngIf="!shouldDisableOption()"
        >
        </mat-icon>
    </div>
</ng-template>

<ng-template #optionsContainer>
    <div class="options-container" #optionElementRef>
        <div
            data-cy="user-share-access-dropdown-item"
            *ngFor="let accessSetting of accessSettingTypeArray"
            class="access-option-wrapper"
            [ngClass]="{
                settingSelected: accessSetting.accessType === currentAccess
            }"
            (click)="changeAccess(accessSetting)"
        >
            <mat-icon class="lock-icon" svgIcon="{{ accessSetting.icon }}">
            </mat-icon>
            <div>
                {{
                    accessTypeTile.concat(".", accessSetting.accessType)
                        | translate
                }}
            </div>
        </div>
    </div>
</ng-template>
